module.exports = __webpack_public_path__ + "media/images/arrow-dwnld-c4c6de8b69fc6b94869cf0bed7e98b00.png";